// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3vULN","tab":"ProcedureTabs_tab__3scfC"};